import { Device } from "@services/devices/types";
import { ConferenceParticipant } from "@services/meetings/types";

export const participantSortFn = (
  a: ConferenceParticipant,
  b: ConferenceParticipant
) => {
  const roomCompare = (a.room?.name ?? "").localeCompare(b.room?.name ?? "");
  if (roomCompare !== 0) return roomCompare;
  const deviceCompare = (a.device?.name ?? "").localeCompare(
    b.device?.name ?? ""
  );
  if (deviceCompare !== 0) return deviceCompare;
  return (a.device?.id ?? "").localeCompare(b.device?.id ?? "");
};
